<template lang="pug">
div(v-if="!$conf.isVrn")
  .d-flex.align-center.gap-6.mt-5.mb-4.text-center
    v-divider
    p.redesignDisabledText--text или
    v-divider
  template(v-if="!slim")
    p.redesignPrimary--text.weight-500.body-1.text-center Быстрая регистрация через
  .d-flex.full-width.justify-center.gap-16.mt-4(
    :class="{ 'flex-column': slim }"
  )
    template(v-for="(service, index) in registerServices")
      app-button.flex-1.rounded-12(
        :key="index"
        outlined
        :size="36"
        @click="service.click"
      )
        v-icon.mr-1 {{ service.icon }}
        p {{ service.text }}
</template>

<script>
export default {
  name: 'FastRegisterForm',
  components: {},
  props: {
    slim: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      registerServices: [
        {
          icon: '$vk',
          text: 'Вконтакте',
          click: () => this.simpleAuthRedirect(this.$rApi.user.getSimpleAuthUriVk),
        },
        {
          icon: '$i-telegram',
          text: 'Телеграм',
          // click: () => this.simpleAuthRedirect(this.$rApi.user.getSimpleAuthUriTg),
          click: this.openTgBlockDialog,
        },
      ],
    };
  },
  created() {},
  methods: {
    simpleAuthRedirect(method) {
      const { name, path } = this.$route;
      if (name !== 'login') {
        localStorage.setItem('redirect', path);
      }
      method().then(({ response }) => {
        const { uri } = response.data.data;
        if (uri) {
          window.location.href = uri;
        }
      });
    },
    openTgBlockDialog() {
      this.$dialogs.confirm({
        attrs: {
          method: () => {},
          title: 'Вход через сторонний сервис',
          message: `В связи с вступлением в силу положений российского законодательства
            о запрете авторизации через сервисы аутентификации, принадлежащие иностранцам, возможность входа через телеграмм ограничена
            до возвращения Павла Дурова в Российское гражданство. Если вы активно пользовались учётной записью, вход в которую осуществлялся
            только через телеграмм - рекомендуем авторизоваться через VK. Если ваши данные будут идентичны, вы сможете связать аккаунты`,
          messageAttrs: {
            class: 'text-justify',
          },
          closeBtnAttrs: {
            class: 'd-none',
          },
          confirmBtnAttrs: {
            class: 'mx-auto px-12 fit-content-width',
            'btn-text': 'Понятно',
          },
        },
      });
    },
  },
};
</script>
